// Romanian translations, merged into DICT by i18n/index.js
export const RO = {
  "nav.vision": "Viziune",
  "nav.programme": "Program",
  "nav.bio": "Cine sunt",
  "nav.adhesion": "Adeziune",
  "nav.contact": "Contact",
  "nav.cta": "Susține",

  "hero.badge": "PRR — Partidul Resetării și Relansării · Prezidențiale 2027",
  "hero.t1": "Pentru Franța,",
  "hero.t2": "evidența.",
  "hero.desc": "Să redăm sens acțiunii publice, să împăcăm ambiția economică cu justiția socială și să readucem cetățeanul în centrul deciziei.",
  "hero.cta1": "Alătură-te mișcării",
  "hero.cta2": "Descoperă programul",
  "hero.scroll": "Derulează",

  "ann.label": "Anunț oficial",
  "ann.title": "Viitorul guvern dezvăluit pe 25 decembrie.",
  "ann.desc1": "Drept cadou de Crăciun pentru francezi, Gilles de Buretel de Chassey va prezenta componența completă a viitorului său guvern pe ",
  "ann.date": "25 decembrie",
  "ann.desc2": ".",
  "ann.days_one": "zi rămasă",
  "ann.days_other": "zile rămase",

  "stats.supporters": "Susținători",
  "stats.volunteers": "Voluntari",
  "stats.departments": "Departamente",

  "prog.eyebrow": "Program 2027 — Notă de economie politică",
  "prog.title": "Să pornim de la o pagină albă.",
  "prog.desc": "Reconstruirea economiei și a statului în jurul a opt proiecte structurante, estimate și realizabile într-un singur mandat: necesar net de capital de 133–151 mld€ și 5,45 mld€ economii recurente anuale.",
  "prog.marquee": "PAGINĂ ALBĂ · SUVERANITATE · STAT STRATEG ·",
  "prog.cta": "Citește programul complet",
  "prog.c1t": "France Réseaux",
  "prog.c1d": "Fuzionarea energiei, apei și telecomunicațiilor într-un singur operator public.",
  "prog.c2t": "Rail France",
  "prog.c2d": "Unificarea SNCF și RATP într-o singură instituție publică.",
  "prog.c3t": "France Hospitalité",
  "prog.c3d": "Valorificarea celor 97 de milioane de m² din patrimoniul imobiliar al statului.",
  "prog.c4t": "Suveranitate agricolă",
  "prog.c4d": "Transmiterea fermelor, achiziții franceze, prețuri minime.",
  "prog.c5t": "Șoc de simplificare",
  "prog.c5d": "Înghețarea celor 400.000 de norme și rescrierea codului civil în trei luni.",
  "prog.c6t": "Arhitectura statului",
  "prog.c6d": "Șapte ministere depline, restrânse.",
  "prog.c7t": "Apărare",
  "prog.c7d": "Reconstruirea bazei industriale și de capabilități naționale.",
  "prog.c8t": "Simplificarea statului",
  "prog.c8d": "Fuzionarea agențiilor, operatorilor și organismelor consultative.",

  "bio.eyebrow": "Cine sunt",
  "bio.title": "Un inginer-antreprenor în slujba Franței.",
  "bio.p1": "Inginer al École Centrale Paris și absolvent de HEC, am dedicat peste treizeci de ani industriei franceze: aerospațial, apărare, energie și digital. Safran, Naval Group, Parlamentul European, misiuni pentru EDF — apoi antreprenoriatul, fondând INGENIA în jurul hidrogenului și al energiilor de mâine.",
  "bio.p2": "Scriitor și sculptor, constructor de proiecte și de idei, nu provin din establishmentul politic. Convingerea mea este simplă: Franța are talentul, energia și istoria pentru a se relansa. Îi lipsesc o direcție clară și un stat care își ține cuvântul.",
  "bio.photoSub": "Inginer, antreprenor și fondator al PRR",
  "bio.m1": "Studii la École Centrale Paris, apoi la programul Challenge+ al HEC Paris.",
  "bio.m2": "Reconstruiește și face să zboare Éole al lui Clément Ader — Primul Mare Premiu Aerospațial al Aventurii.",
  "bio.m3": "Vicepreședinte pentru noile produse electrice la Safran.",
  "bio.m4": "Conduce divizia de submarine a Naval Group; misiuni pentru EDF.",
  "bio.m5": "Fondează INGENIA, birou de inginerie dedicat energiilor (hidrogen, eolian, solar, aerospațial).",
  "bio.m6": "Candidat la președinția Republicii cu PRR.",

  "sup.eyebrow": "Alătură-te mișcării",
  "sup.title": "Susținerea ta schimbă totul.",
  "sup.desc": "Fiecare semnătură contează. Alătură-te miilor de francezi care își doresc o Franță demnă, mândră și orientată spre viitor.",
  "sup.b1": "Primești programul complet",
  "sup.b2": "Participi la evenimentele locale",
  "sup.b3": "Devii voluntar dacă dorești",
  "sup.first": "Prenume",
  "sup.last": "Nume",
  "sup.email": "Adresă de email",
  "sup.city": "Oraș",
  "sup.postal": "Cod poștal",
  "sup.volunteer": "Doresc să devin voluntar",
  "sup.submit": "Îl susțin pe Gilles de Buretel de Chassey",
  "sup.privacy": "Datele tale sunt folosite exclusiv în cadrul campaniei.",
  "sup.success_title": "Bine ai venit în mișcare!",
  "sup.success_desc": "Ți-am trimis un email de confirmare. Împreună, să facem ca ideile noastre să câștige.",
  "sup.success_another": "Înscrie o altă persoană",
  "sup.toast_ok": "Mulțumim! Te-ai alăturat mișcării.",
  "sup.toast_err": "A apărut o eroare. Încearcă din nou.",

  "adh.eyebrow": "Devino membru",
  "adh.title": "Adeziunea costă 5€.",
  "adh.desc": "O cotizație unică și simbolică de 5€ pentru a face parte din mișcare. Aici nu banii contează, ci angajamentul tău.",
  "adh.b1": "Card oficial de membru PRR",
  "adh.b2": "Drept de vot la consultările interne",
  "adh.b3": "Invitații prioritare la evenimente",
  "adh.b4": "Programul complet și actualizările",
  "adh.per": "/ adeziune",
  "adh.priceNote": "Cotizație unică. Plată securizată prin Stripe.",
  "adh.name": "Nume și prenume",
  "adh.submit": "Ader pentru 5€",
  "adh.redirect": "Vei fi redirecționat către plata securizată Stripe.",
  "adh.err_fill": "Te rugăm să introduci numele și emailul.",
  "adh.err_start": "Nu se poate începe adeziunea.",

  "con.eyebrow": "Scrie-ne",
  "con.title": "O întrebare, o idee?",
  "con.desc": "La PRR funcționăm reactiv, iar președintele rămâne direct accesibil cetățenilor. Un singur punct de contact, un răspuns rapid.",
  "con.cpLabel": "Punct unic de contact",
  "con.subject": "Subiect",
  "con.message": "Mesajul tău",
  "con.name": "Nume",
  "con.email": "Email",
  "con.submit": "Trimite",
  "con.nl_title": "Buletinul campaniei.",
  "con.nl_desc": "În fiecare săptămână: propunerile noastre, agenda și culisele. Direct în inboxul tău.",
  "con.nl_ph": "Emailul tău",
  "con.nl_submit": "Mă abonez",
  "con.toast_sent": "Mesaj trimis. Echipa îți va răspunde în curând.",
  "con.toast_senderr": "Trimiterea a eșuat. Încearcă din nou.",
  "con.toast_nlerr": "Abonarea a eșuat. Încearcă din nou.",

  "foot.desc": "Candidat la alegerile prezidențiale franceze din 2027, pentru Partidul Resetării și Relansării (PRR). Pentru o Franță suverană, prosperă și fraternă.",
  "foot.nav": "Navigare",
  "foot.agir": "Acționează",
  "foot.accessible": "Un PRR reactiv, un președinte accesibil cetățenilor.",
  "foot.copyright": "© 2027 PRR — Partidul Resetării și Relansării. Toate drepturile rezervate.",
  "foot.legal": "Mențiuni legale · Politica de confidențialitate",

  "pay.cancel": "Adeziune anulată. Poți încerca din nou oricând.",
  "pay.success": "Bine ai venit! Adeziunea ta este confirmată. 🇫🇷",
  "pay.expired": "Sesiunea de plată a expirat.",
  "pay.checking": "Se verifică plata...",
  "pay.verify": "Plata este în curs de verificare. Mulțumim!",

  "install.btn": "Instalează aplicația",
  "install.ios": "Pentru a adăuga aplicația: apasă Partajează, apoi „Adaugă pe ecranul principal”.",
  "install.dismiss": "Mai târziu",
  "music.play": "Ascultă Bellini",
  "music.pause": "Pauză",
  "music.volume": "Volum",

  // Programme page
  "pg.back": "Înapoi la pagina principală",
  "pg.pdf": "Descarcă PDF-ul",
  "pg.eyebrow": "Program 2027 · Notă de economie politică",
  "pg.title": "Să pornim de la o pagină albă.",
  "pg.intro": "Franța nu se va reforma prin retușuri mărunte. Acest program propune reconstruirea economiei, administrației și instituțiilor sale în jurul a opt proiecte structurante, estimate pe baza datelor publice și derulate în paralel pe durata unui mandat.",
  "pg.kf": ["Necesar net de capital (2027-2030)", "Economii recurente", "Derulate în paralel pe 4 ani"],
  "pg.chantiersTitle": "Cele opt proiecte",
  "pg.c1.lead": "Fuzionarea energiei, apei și telecomunicațiilor într-un operator public integrat.",
  "pg.c1.points": ["Reunește EDF (deja publică), apa (Veolia, Suez, Saur — 69% din distribuție) și telecomunicațiile (Orange, SFR, Bouygues Telecom, Free).", "Cost estimat de preluare (fără EDF): circa 140–155 mld€, repartizat pe mai mulți ani.", "Un statut unic de contractual de drept public pune capăt regimurilor speciale moștenite de la monopoluri.", "Demonstratorul INGENIA ilustrează convergența fizică a rețelelor la client (fotovoltaic, apă, satelit, hidrogen)."],
  "pg.c2.lead": "Unificarea SNCF și RATP într-o singură instituție publică.",
  "pg.c2.points": ["Sfârșitul coexistenței a două grupuri publice: ≈ 50 mld€ cifră de afaceri cumulată, ≈ 357.500 de angajați.", "Fără cost de achiziție (entități publice), dar un efort de guvernanță și armonizare socială.", "Câștiguri: achiziții comune, centre de mentenanță partajate și un sistem unic de ticketing."],
  "pg.c3.lead": "Valorificarea patrimoniului imobiliar inactiv al statului.",
  "pg.c3.points": ["71,9 mld€ în active, 97 de milioane de m², peste 195.000 de clădiri, astăzi subutilizate.", "Audit sistematic, apoi conversie (adăpost de urgență, co-localizarea serviciilor publice) sau vânzare.", "Potențial de valorificare: de la 3,6 mld€ (5% din patrimoniu) la 7,2 mld€ (10%)."],
  "pg.c4.lead": "Oprirea pierderii a 40.000 de ferme în patru ani.",
  "pg.c4.points": ["Plan național de transmitere: garanție publică de instalare și preluare temporară a terenurilor.", "Reorientarea achizițiilor publice către aprovizionarea franceză.", "Politică de prețuri minime pentru producțiile structural deficitare."],
  "pg.c5.lead": "Reducerea unui stoc de aproape 400.000 de norme.",
  "pg.c5.points": ["Înghețarea imediată a stocului de norme nebugetare.", "Interzicerea supratranspunerii textelor europene, cu excepția unui vot expres al Parlamentului.", "Clauză de reexaminare automată pentru orice normă nouă.", "Rescrierea codului civil în trei luni, după modelul comisiei Portalis."],
  "pg.c6.lead": "Recompunerea executivului în jurul a șapte portofolii restrânse.",
  "pg.c6.points": ["Ministere depline: Afaceri Externe; Justiție și Interne; Război și Forțe de Ordine; Dezvoltare Economică; Agricultură; Descentralizare; Tranziție Constituțională.", "Noi operatori: France Éducation et Culture (≈ 68 mld€), France Travail (acompaniere și plată separate).", "O guvernanță care îmbină acțiunea rapidă cu perspectiva pe termen lung."],
  "pg.c7.lead": "Reconstruirea bazei industriale și de capabilități naționale.",
  "pg.c7.points": ["Relansarea manufacturii de armament de la Saint-Étienne.", "Studiul unei noi generații navale (portavion catamaran) — cost indicativ 45–70 mld€.", "Programul MELOMANIA: demonstrator de lovire și recunoaștere hipersonică și roi de drone coordonate prin IA."],
  "pg.c8.lead": "Raționalizarea a 103 agenții, 434 de operatori și 317 organisme consultative.",
  "pg.c8.points": ["Fuzionarea structurilor redundante și desființarea agențiilor învechite.", "Transferul misiunilor agențiilor regionale de sănătate către serviciile deconcentrate ale statului.", "Economii din raționalizare estimate la circa 550 mil€ pe an."],
  "pg.finTitle": "Bilanț financiar",
  "pg.finHead": "Un proiect finanțabil și transparent.",
  "pg.fin": ["Necesar net de finanțare în capital (unic, prin împrumut de stat sau datoria operatorilor).", "Valorificarea patrimoniului prin France Hospitalité.", "Economii recurente (sfârșitul privilegiilor + simplificare).", "Randament direct al activelor achiziționate (ex.: dividendul EDF)."],
  "pg.implEyebrow": "Implementare",
  "pg.implTitle": "Patru ani pentru a face schimbarea ireversibilă.",
  "pg.timeline": [
    { tag: "Demarare", text: "Votarea legii-cadru, crearea juridică a celor trei instituții, deschiderea negocierilor de preluare, închiderea regimurilor speciale pentru noii angajați." },
    { tag: "Constituire", text: "Transferul proprietății (Veolia, Suez, Saur, Orange), fuziunea SNCF-RATP, primele efecte bugetare." },
    { tag: "Desfășurare", text: "Integrare tehnică și tarifară, ticketing unic, ofertă convergentă pilot, extinderea noilor ministere." },
    { tag: "Generalizare", text: "Bilanț cuantificat și audit independent transmise Parlamentului pentru a face schimbarea ireversibilă." },
  ],
  "pg.vigTitle": "Puncte de vigilență asumate",
  "pg.vig": ["Financiar: costul de 140–155 mld€ ridică problema vehiculului de finanțare și a riscului de litigii cu acționarii.", "European: fuziunile din telecom și apă vor trebui să respecte dreptul concurenței și ajutoarele de stat.", "Social: drepturile dobândite în regimurile speciale rămân protejate; doar noii angajați intră sub statutul unificat.", "Instituțional: ideea unei monarhii constituționale, propusă ca temă de dezbatere, se lovește de articolul 89 din Constituție."],
  "pg.ctaAdh": "Susține acest proiect — adeziune pentru 5€",
};
